import React, { useState, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  MasterDetail,
  Button,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import swal from "sweetalert";
import axios from "axios";
import Guid from "devextreme/core/guid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CustomerMasterDetailView from "./CustomerMasterDetailView";
import useDeviceSize from "../../hooks/useDeviceSize";
import AddLeadModal from "./AddLeadModal";
import { api_path } from "../../shared.js";
export function LeadsManagementDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [modeSize, setModeSize] = useState("widget");
  const classes = useStyles();
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [getEmpID, setEmpID] = useState(props.EMP_CODE);

  const [GET_SMF_CODE, SET_SMF_CODE] = useState("");
  const [GET_CUSTOMER_NAME, SET_CUSTOMER_NAME] = useState("");
  const [GET_TAXID, SET_TAXID] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const pageSizes = [25, 50, 100];
  const url =
    api_path + "/customer/leads.php?SALES_CODE=" + getEmpID + "&role=" + getUserRole;
  const token = process.env.REACT_APP_API_TOKEN;
  const dataSource = createStore({
    key: "LEAD_ID",
    loadUrl: url,
    reshapeOnPush: true,
    onBeforeSend(method, ajaxOptions) {
      ajaxOptions.crossDomain = true;
      ajaxOptions.xhrFields = { withCredentials: true };
      ajaxOptions.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    },
  });
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "SOURCE_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button source-" +
                      (e.data.SOURCE_NAME).toLowerCase() +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.SOURCE_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "STATUS_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button status-" +
                      e.data.STATUS_NAME +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.STATUS_NAME +
          "</a></span>";
      }
       if (e.column.dataField === "TAG_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button tag-" +
            e.data.TAG_NAME.toLowerCase().replace(/\s/g, '-') +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.TAG_NAME +
          "</a></span>";
      }
    }
  };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Leads.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const navigate = useNavigate();

  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    const result = dataRow.DESTINATION_COUNTRY;
    //window.location = "./#/Customer?id=" + e.row.key
    navigate({
      pathname: "/LeadsForm",
      search: "?id=" + e.row.key,
    });
  }, []);
  const deleteConfirm = React.useCallback((e) => {
    const key = new Guid().toString();
    // if (window.confirm("Delete Master Data id=" + e.row.key)) {
    //   deleteUser(e.row.key);
    // }
    swal({
      title: "Are you sure?",
      text: "You want to delete this data?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteRow(e.row.key);
      }
    });
  }, []);

  const deleteRow = async (id) => {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `/customer/customers.php?id=${id}`
      );
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };
  const onRefreshClick = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleSearch = (e) => {
    //setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleClearInputClick = () => {
    // setDateStr("Please click Search button to refresh data.");
    // if (getUserRole == 1) {
    //   setSelectSale(getCrmId);
    //   setSale({
    //     SALE_CODE: getCrmId,
    //     SALE_NAME: getUserID,
    //   });
    //   setSaleAuthenCode(getEmpCode);
    // } else if (getUserRole == 3) {
    //   setSale([]);
    //   setSelectSale([]);
    // }
    setStatus([]);
    setSelectStatus([]);
  };
  const handleAddButtonClick = React.useCallback((e) => {
    window.open("/s-crm/LeadsForm", "_blank");
  }, []);
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <label className="head">Leads Management</label>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          style={{ display: "flex" }}
          justify="flex-end"
        >
           {/* <Button1
            className="searchButton"
            //disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            Upload Batch
          </Button1> */}
          </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          style={{ display: "flex" }}
          justify="flex-end"
        >
       
          {/* <Button1
            className="addBtn"
            //disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            New Leads
          </Button1> */}
           <AddLeadModal
              // ORDER_ID={order_id}
              // USER_ID={getCrmId}
              // ORDER_STATUS={GET_ORDER_STATUS_ID}
            />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>CONTACT NAME</label>
          <TextField
            size="small"
            name="GET_SMF_CODE"
            variant="outlined"
            fullWidth
            id="GET_SMF_CODE"
            value={GET_SMF_CODE}
            onChange={(e) => SET_SMF_CODE(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>EMAIL</label>
          <TextField
            size="small"
            name="GET_CUSTOMER_NAME"
            variant="outlined"
            fullWidth
            id="GET_CUSTOMER_NAME"
            value={GET_CUSTOMER_NAME}
            onChange={(e) => SET_CUSTOMER_NAME(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>PHONE</label>
          <TextField
            size="small"
            name="GET_TAXID"
            variant="outlined"
            fullWidth
            id="GET_TAXID"
            value={GET_TAXID}
            onChange={(e) => SET_TAXID(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>STATUS</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>CAMPAIGN</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>TAG</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          id="CustomerContainer"
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="LEAD_ID"
          onExporting={onExporting}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
        >
          <Paging enabled={true} />
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <MasterDetail enabled={true} component={CustomerMasterDetailView} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />

          <Column dataField="LEAD_ID" visible={false} />
          <Column dataField="CONTACT_NAME" caption="CONTACT NAME" />
          <Column dataField="CONTACT_EMAIL" caption="EMAIL" />
          <Column dataField="CONTACT_PHONE" caption="PHONE" />
          <Column dataField="STATUS_NAME" caption="STATUS" />
          <Column dataField="SOURCE_NAME" caption="CAMPAIGN" />
          <Column dataField="TAG_NAME" caption="TAG" />
          <Column dataField="FNAME" caption="SALES" />

          <Column type="buttons" caption="ACTIONS">
            <Button icon="edit" onClick={onEditButtonClick} />
            <Button icon="event" onClick={onEditButtonClick} />
            <Button icon="comment" onClick={deleteConfirm} />
          </Column>
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
